import { useNavigate } from 'react-router-dom';

import { usePlatformConfig } from '@/hooks';

export default function Logo() {
  const navigate = useNavigate();
  const { platformConfig } = usePlatformConfig();

  return (
    <div onClick={() => navigate('/home')} style={{ marginRight: '12px', width: '124px', height: '44px' }}>
      <img
        style={{ cursor: 'pointer', width: '100%', height: '100%', objectFit: 'contain' }}
        src={platformConfig.logoURL}
        alt="logo"
        onError={(event) => {
          event.currentTarget.src = '/images/logo.svg';
        }}
      />
    </div>
  );
}
